<template>
    <div class="single-book-detail">
        <PageHeader></PageHeader>
        <!-- {{ this.$store.state.bookDetailId }} -->
        <div class="book-detail" v-if="detailItem">
            <div class="thumd">
                <img :src="getImgCover(detailItem.cover)" alt="" />
                <span v-if="detailItem.allowFree"><van-tag mark type="primary">免费</van-tag></span>
            </div>

            <div class="book-detail-word">
                <h3>{{ detailItem.title }}</h3>
                <div class="detail-ac">
                    <span class="book-author">{{ detailItem.author }}</span>
                    <span class="book-copyright">{{ detailItem.copyright }}</span>
                </div>
                <div class="detail-cw">
                    <!-- <p>{{ item.shortIntro }}</p> -->
                    <span class="book-cat">{{ detailItem.cat }}</span>
                    <span class="book-wordCount">{{ getWordCount(detailItem.wordCount) }}</span>
                </div>
            </div>
        </div>

        <ul class="reader-data" v-if="detailItem">
            <li v-if="detailItem.rating" class="score">
                <p>
                    <span>{{ getFix(detailItem.rating.score) }}</span>
                    <van-rate v-model="value" allow-half void-icon="star" void-color="#eee" :readonly="true" size="10px" />
                </p>
                <p>{{ detailItem.rating.tip }}</p>
            </li>
            <li>
                <p>{{ detailItem.retentionRatio }}%</p>
                <p>读者留存</p>
            </li>
            <li>
                <p>{{ getFollower(detailItem.latelyFollower) }}</p>
                <p>7日人气</p>
            </li>
            <li>
                <p>{{ getFollower(detailItem.totalFollower) }}</p>
                <p>累计人气</p>
            </li>
        </ul>

        <div class="introduction" v-if="detailItem">
            <h5>简介</h5>
            <span v-for="(item, index) in detailItem.tags" :key="index">{{ item }}</span>
            <p :class="{ active: isActive }" @click="isActive = !isActive">
                {{ detailItem.longIntro }}
                <span>
                    <van-icon name="arrow-up" v-if="isActive" />
                    <van-icon name="arrow-down" v-else />
                </span>
            </p>
        </div>
        <!-- 目录 -->
        <div class="catalogue-detail" @click="$router.push({ path: 'cataloguepage' })" v-if="detailItem">
            <span class="catalogue">目录</span>
            <!-- <div class="update-content"> -->
            <span v-if="detailItem.isSerial" :class="{ isSerial: detailItem.isSerial }">{{ timeMaker(detailItem.updated) }}</span>
            <span v-else>已完结</span>
            <span>{{ detailItem.lastChapter }}<van-icon name="arrow" size="16px"/></span>
            <!-- </div> -->
        </div>
        <!-- 短评 -->
        <div class="short-reviews" v-if="bookShortReviewsPart">
            <h5 class="title">热门短评</h5>
            <ul class="content">
                <BookReviews v-for="(item, index) in bookShortReviewsPart" :key="index" :item="item"></BookReviews>
            </ul>
            <div class="examine-more">查看全部短评</div>
        </div>
        <!-- 书评 -->
        <div class="book-reviews" v-if="bookReviewsPart">
            <h5 class="title">热门书评</h5>
            <ul class="content">
                <BookReviews v-for="(item, index) in bookReviewsPart" :key="index" :item="item"></BookReviews>
            </ul>
            <div class="examine-more">全部书评</div>
        </div>
        <!-- 底部跳转台 -->
        <div class="control">
            <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
                <van-button type="default" slot="title" @click="onClickTitle">开始阅读</van-button>
                <van-icon name="plus" slot="left" size="20px" />
                <van-button type="default" slot="left">追更新</van-button>
                <van-icon name="down" slot="right" size="20px" />
                <van-button type="default" slot="right">下载</van-button>
            </van-nav-bar>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import BookReviews from "@/components/BookReviews.vue";

export default {
    data() {
        return {
            bookId: null,
            detailItem: null,
            value: null,
            isActive: false,
            bookShortReviews: null,
            bookReviews: null,
            bookShortReviewsPart: null,
            bookReviewsPart: null
        };
    },
    components: {
        PageHeader,
        BookReviews
    },
    computed: {},
    methods: {
        onClickTitle() {
            this.$router.push({ path: "cataloguepage" });
        },
        onClickLeft() {
            window.console.log("xxx");
        },
        onClickRight() {
            window.console.log("xxx");
        },
        getFix(num) {
            return num.toFixed(1);
        },
        timeMaker(t) {
            var date = new Date(t); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var now = new Date();

            var Y = date.getFullYear();
            var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var D = date.getDate();
            var h = date.getHours();
            var m = date.getMinutes();
            var s = date.getSeconds();
            var NY = now.getFullYear();
            var NM = now.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var ND = now.getDate();
            var Nh = now.getHours();
            var Nm = now.getMinutes();
            var Ns = now.getSeconds();

            if (NY - Y > 0) {
                return NY - Y + "年前更新";
            } else if (NM - M > 0) {
                return NM - M + "月前更新";
            } else if (ND - D > 0) {
                return ND - D + "天前更新";
            } else if (Nh - h > 0) {
                return Nh - h + "时前更新";
            } else if (Nm - m > 0) {
                return Nm - m + "分前更新";
            } else if (Ns - s > 0) {
                return Ns - s + "秒前更新";
            }
            // this.bookDetails.updated = Y + M + D + h + m + s;
        },
        getFollower(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(1) + "万";
            } else {
                return num;
            }
        },
        getWordCount(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(0) + "万字";
            } else {
                return num + "字";
            }
        },
        getImgCover(url) {
            return "https://statics.zhuishushenqi.com" + url;
        },
        // getBookDetailInfo() {
        //     window.console.log("this.query.id ", this.$route.query.id);

        //     this.bookId = this.$route.query.id;
        //     this.bookId = this.$store.state.bookDetailId;
        //     this.axios.get("https://novel.kele8.cn/book-info/" + this.bookId).then(response => {
        //         // window.console.log(response.data);
        //         ({ data: this.detailItem } = response);
        //         localStorage.setItem(
        //             "detailItem" + this.bookId,
        //             JSON.stringify({
        //                 time: Date.now(),
        //                 data: this.detailItem
        //             })
        //         );
        //     });
        // },
        getBookDetailInfo(id) {
            // window.console.log("this.query.id ", this.$route.query.id);
            id = this.$store.state.bookDetailId;
            this.axios.get("https://novel.kele8.cn/book-info/" + id).then(response => {
                this.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });
                // window.console.log(response.data);
                ({ data: this.detailItem } = response);
            }).finally(this.$toast.clear());
        },
        getBookShortReviews(id) {
            // let bookShortReviews = localStorage.getItem("bookShortReviews" + this.bookId);
            // if (bookShortReviews && Date.now() < JSON.parse(bookShortReviews).time + 60 * 60 * 1000) {
            //     this.bookShortReviews = JSON.parse(bookShortReviews).data;
            // } else {
            this.bookId = this.$store.state.bookDetailId;
            this.axios
                .get("https://novel.kele8.cn/book/short-reviews", {
                    params: {
                        book: id
                    }
                })
                .then(response => {
                    window.console.log(response.data);
                    ({ docs: this.bookShortReviews } = response.data);
                    this.bookShortReviewsPart = this.bookShortReviews.slice(0, 5);
                    localStorage.setItem(
                        "bookShortReviews" + this.bookId,
                        JSON.stringify({
                            time: Date.now(),
                            data: this.bookShortReviews
                        })
                    );
                });
            // }
        },
        getBookReviews(id) {
            // let bookReviews = localStorage.getItem("bookReviews" + this.bookId);
            // if (bookReviews && Date.now() < JSON.parse(bookReviews).time + 60 * 60 * 1000) {
            //     this.bookReviews = JSON.parse(bookReviews).data;
            // } else {
            this.bookId = this.$store.state.bookDetailId;
            this.axios
                .get("https://novel.kele8.cn/book/reviews", {
                    params: {
                        book: id
                    }
                })
                .then(response => {
                    window.console.log(response.data);
                    ({ reviews: this.bookReviews } = response.data);
                    this.bookReviewsPart = this.bookReviews.slice(0, 5);
                    localStorage.setItem(
                        "bookReviews" + this.bookId,
                        JSON.stringify({
                            time: Date.now(),
                            data: this.bookReviews
                        })
                    );
                });
            // }
        }
    },
    beforeRouteEnter(to, from, next) {
        // ...
        next(vm => {
            vm.getBookDetailInfo(to.query.id);
            vm.getBookReviews(to.query.id);
            vm.getBookShortReviews(to.query.id);
        });
    },
    updated() {
        this.value = this.detailItem.rating.score / 2;
    }
};
</script>

<style lang="less" scope>
.single-book-detail {
    margin-bottom: 50px;
    .control {
        position: relative;
        .van-nav-bar {
            // background: lightgray;
            position: fixed;
            width: 100%;
            height: 8vh;
            bottom: 0;
            left: 0;
            z-index: 99;
            border-top: 1px solid rgb(240, 240, 240);
            .van-button {
                border: none;
                outline: none;
                color: red;
                padding: 0;
                font-size: 16px;
                line-height: 8vh;
                &:active {
                    &::before {
                        opacity: 0;
                    }
                }
                &:first-child {
                    width: 100%;
                    height: 100%;
                    color: #ffffff;
                    background: rgb(184, 51, 32);
                    font-size: 18px;
                }
            }
            .van-nav-bar__title {
                max-width: 40%;
            }
            .van-nav-bar__right {
                right: 30px;
                line-height: 8vh;
            }
            .van-nav-bar__left {
                left: 20px;
                line-height: 8vh;
            }
            .van-icon {
                color: red;
                top: -2px;
            }
        }
    }
    .book-detail {
        padding: 25px 15px 30px;
        background: #333;
        .thumd {
            position: relative;
            width: 100%;
            img {
                float: left;
                width: 70px;
                // height: 100px;
                margin-right: 20px;
                border-radius: 2px;
                box-shadow: 0 2px 1px 2px rgba(0, 0, 0, 0.15);
            }
            span {
                position: absolute;
                top: 0;
                left: -2px;
                font-size: 10px;
                transform: scale(0.9);
                width: 25px;
                background: rgb(255, 210, 30);
                color: rgb(85, 68, 2);
                .van-tag {
                }
            }
        }
        .book-detail-word {
            h3 {
                font-size: 18px;
                margin: 5px 0;
                color: #ffffff;
            }
            .montant() {
                content: "|";
                display: inline-block;
                margin: 0 20px;
                color: #999;
            }
            .detail-ac {
                display: flex;
                span {
                    // flex: 1;
                    &.book-author {
                        color: rgb(255, 215, 0);
                        &::after {
                            .montant;
                        }
                    }
                    &.book-copyright {
                        color: #999;
                    }
                }
            }
            .detail-cw {
                display: flex;
                span {
                    // flex: 1;
                    &.book-cat {
                        color: rgb(255, 215, 0);

                        &::after {
                            .montant;
                        }
                    }
                    &.book-wordCount {
                        color: #999;
                    }
                }
            }
        }
    }
    ul.reader-data {
        padding: 15px;
        display: flex;
        justify-content: space-around;
        border-bottom: 10px solid rgb(245, 244, 244);

        li {
            &.score {
                position: relative;
                p {
                    &:last-child {
                        text-align: left;
                        position: absolute;
                        left: -10px;
                        font-size: 8px;
                        transform: scale(0.8);
                    }
                    display: flex;
                    span {
                        flex: 1;
                        font-size: 18px;
                    }
                    .van-rate {
                        position: relative;
                        top: 7px;
                    }
                }
            }
            flex: 1;
            font-size: 14px;
            text-align: center;
            color: #666;
            p {
                margin: 0;
                .van-rate {
                    // font-size: 10px;
                }
            }
        }
    }
    .introduction {
        padding: 0 15px;

        h5 {
            font-size: 16px;
            margin: 20px 0 10px;
        }
        & > span {
            font-size: 12px;
            color: #999;
            background: rgb(241, 241, 241);
            padding: 2px 5px;
            border-radius: 10px;
            margin: 0 3px;
        }
        p {
            position: relative;
            white-space: pre-wrap;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            color: #666;
            font-size: 14px;
            margin: 20px 0;
            // padding-bottom: 20px;
            &.active {
                display: block;
            }
            span {
                position: absolute;
                right: 0px;
                bottom: -5px;
                .van-icon {
                }
            }
        }
    }
    .catalogue-detail {
        border-top: 1px solid rgb(240, 240, 240);
        border-bottom: 10px solid rgb(245, 244, 244);
        padding: 15px 0;
        display: flex;
        span {
            flex: 1 0 auto;
            padding-left: 15px;
            color: #666;
            line-height: 20px;
            &:last-child {
                color: #999;
                font-size: 12px;
                display: -webkit-box;
                padding: 0;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                position: relative;
                .van-icon {
                    position: absolute;
                    right: 5px;
                    top: 2px;
                }
            }
            &:nth-child(2) {
                font-size: 12px;
                text-align: left;
                color: #999;
                width: 30px;
                &.isSerial {
                    color: red;
                }
            }
            &.catalogue {
            }
            .van-icon {
                top: 2px;
            }
        }
    }
    .short-reviews,
    .book-reviews {
        h5.title {
            padding: 0 0 15px 15px;
            margin-bottom: 15px;
            font-size: 16px;
            border-bottom: 1px solid rgb(241, 241, 241);
        }
        ul.content {
            li {
            }
        }
        .examine-more {
            color: red;
            text-align: center;
            padding: 10px 0;
            border-top: 1px solid rgb(241, 241, 241);
            border-bottom: 10px solid rgb(245, 244, 244);
        }
    }
}
</style>
